import { Tabs } from 'antd'
import React from 'react'
import { t } from 'i18next'
import InformationsTab from './InformationsTab'
import EventsTab from './EventsTab'
import FeedbackForm from './FeedbackForm'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export default function AdminSlotTabs ({ slot, setLoading, setSlot }) {
  const screens = useBreakpoint()
  const maxHeight = screens.xxl ? '52vh' : screens.xl ? '81vh' : '127vh'
  const defaultTabStyle = { overflowY: 'scroll', maxHeight }

  return (
    <Tabs
      defaultActiveKey='informations'
      items={[
        {
          label: t('Admin.AdminSlotPage.tab.informations'),
          key: 'informations',
          children: <InformationsTab slot={slot} setLoading={setLoading} style={defaultTabStyle} />
        },
        {
          label: t('Admin.AdminSlotPage.tab.events'),
          key: 'events',
          children: <EventsTab slot={slot} setLoading={setLoading} style={defaultTabStyle} />
        },
        {
          label: t('Admin.AdminSlotPage.tab.feedback'),
          key: 'feedback',
          children: <FeedbackForm slot={slot} setLoading={setLoading} setSlot={setSlot} style={defaultTabStyle} />
        }
      ]}
    />
  )
}
